<div class="register-another-appliance">
  <p class="register-another-appliance__title">
    {{ "REGISTER_ANOTHER_APPLIANCE_TITLE" | translate }}
  </p>

  <app-icon-list
    [iconTemplate]="iconTemplateRegisterAnotherAppliance"
    [items]="iconListItems"
  >
    <ng-template #iconTemplateRegisterAnotherAppliance let-icon="iconName">
      <app-icon
        [family]="'solid'"
        [name]="icon"
        [size]="'lg'"
        class="register-another-appliance__icon"
      />
    </ng-template>
  </app-icon-list>

  <app-button
    (click)="onRegisterAnotherAppliance()"
    [fill]="true"
    [variant]="'primary-alternative'"
    class="register-another-appliance__button"
    >{{ "REGISTER_ANOTHER_APPLIANCE_BUTTON" | translate }}</app-button
  >
</div>
